module.exports = __webpack_public_path__ + "img/18-5 (RedteaGO Global eSIM Plan) _zh.7e27f013.png";